// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Flamethrower",
  id: "flamethrower",
  metadata: {
    aspect: SavedSpellAspect.Fire,
    imports: ["fire","spark","self","wait"],
    icon: {
      "backgroundColor": 4200746,
      "layers": [
        {
          "iconKey": "fireball",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -3,
          "color": 16492879
        },
        {
          "iconKey": "lightning",
          "position": {
            "x": 16,
            "y": -4
          },
          "scale": 0.57,
          "rotation": -11,
          "color": 16763904
        },
        {
          "iconKey": "delay",
          "position": {
            "x": -13,
            "y": -2
          },
          "scale": 0.61,
          "rotation": -3,
          "color": 16054783
        }
      ]
    },
  },
};

export default metadata;
